<template>
  <Toolbar :class="['custom-toolbar', className]">
    <template #start>
      <slot name="start" />
    </template>

    <template #center>
      <slot name="center" />
    </template>

    <template #end>
      <slot name="end" />
    </template>
  </Toolbar>
</template>

<script setup lang="ts">
import Toolbar from 'primevue/toolbar';

// Props definieren
defineProps({
  className: {
    type: String,
    default: '',
  },
});
</script>

<style scoped lang="css">
.secondaryToolbar.custom-toolbar {
  border: none;
  background-color: transparent;
}
</style>
